<template>
  <span class="card-wrapper flex-noshrink">
    <i
      class="card card-single"
      v-if="count === 1"
    />
    <i
      class="card-multiple"
      v-else>
      <span class="card-count font-bold font-normal">
        {{ count }}
      </span>
    </i>
  </span>
</template>

<script>
export default {
  name: 'CardRed',
  props: {
    count: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.card-wrapper {
  position: relative;
  width: 1.19792vw;
  height: 3.24077vh;
  margin: 0 7px;
}

.card {
  position: absolute;
  width: 0.78125vw;
  height: 2.31481vh;
  top: 0.463vh;
  left: 0.260417vw;
  border-radius: 0.20833vw;
  background-color: $match-card-red;
}

.card-count {
  position: absolute;
  top: 0.463vh;
  right: 0.15625vw;
  color: $match-card-red-count-color;
  font-size: 0.5rem;
  line-height: initial;
}

.card-multiple {
  display: block;
  background: url('../../../assets/img/card-red.svg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}
</style>
